import {
  ChangeDetectorRef,
  Component,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SecondPageIndexBase } from 'vnpost-shared';
import { CreateCommissionsForSaleComponent } from './create-commissions-for-sale/create-commissions-for-sale.component';
import { EditCommissionsForSaleComponent } from './edit-commissions-for-sale/edit-commissions-for-sale.component';
import { CommissionsForSaleService } from '../services/commissions-for-sale.service';

@Component({
  selector: 'app-commissions-for-sale',
  templateUrl: './commissions-for-sale.component.html',
  styleUrls: ['./commissions-for-sale.component.css']
})
export class CommissionsForSaleComponent extends SecondPageIndexBase implements OnInit {
  @ViewChild('pCreate', { static: false }) pCreate: CreateCommissionsForSaleComponent;
  @ViewChild('pEdit', { static: false }) pEdit: EditCommissionsForSaleComponent;
  code: any;
  setWidth: string = '100%';
  formGroup: UntypedFormGroup;
  constructor(
    private router: Router,
    private _service: CommissionsForSaleService,
    private cd: ChangeDetectorRef,
    protected _injector: Injector
  ) {
    super(_service, _injector);
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl(''),
    });
    this.cols = [
      {
        field: 'stt',
        header: 'STT',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'code',
        header: 'Mã kênh bán',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'name',
        header: 'Tên kênh bán',
        visible: true,
        sort: false,
        width: 10,
      },
      {
        field: 'proportion',
        header: 'Tỷ lệ hoa hồng(%)',
        visible: true,
        sort: false,
        width: 10,
      },
      {
        field: 'note',
        header: 'Ghi chú',
        visible: true,
        sort: false,
        width: 10,
      },
      {
        field: 'status',
        header: 'Trạng thái áp dụng',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'action',
        header: 'Hành động',
        visible: true,
        sort: false,
        width: 15,
      },
    ];
  }
  ngOnInit(): void {
    this.getData();
  }

  search() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.totalRecord = 0;
    this.getData();
  }

  getData() {
    this.isLoading = true;
    this.code = this.code ? this.code.trim() : '';
    var model = {
      code: this.code ?? '',
      pageNo: this.pageIndex - 1,
      pageSize: this.pageSize
    };
    var index= model.pageNo*model.pageSize
    this._service
      .getListCommissionsForSale(model)
      .then((res) => {
        if (res) {
          
          this.dataSource = res.data;
          if(this.dataSource){
            this.dataSource.forEach(e => {
              index++
              e.stt=index
            });
          }
          this.totalRecord = res.total;
        }
      })
      .finally(() => (this.isLoading = false));
  }

  editCommissionsForSale(item: any, isDisable: boolean) {
    if (item && item.id)
      var model = {
        id: item.id,
        isDisable: isDisable,
      };
     this.pEdit.showPopup(model);
  }
  deleteCommissionsForSale(item: any) {
    if (item && item.id && item.status) {
      this._notifierService
        .showConfirm('Bạn có chắc muốn ngừng hoạt động hoa hồng theo kênh bán này')
        .then((res) => {
          if (res) {
            // this._service.delete(item.identifier).then(
            //   () => {
            //     this._notifierService.showDeleteDataSuccess();
            //     this.getData();
            //   },
            //   () => {
            //     this._notifierService.showDeleteDataError();
            //   }
            // );
            this._service.inactive(item.id).then(
              (response) => {
                this._notifierService.showUpdateDataSuccess();
                this.getData();
              },
              (error) => {
                this._notifierService.showUpdateDataFailed();
              }
            );
          }
        });
    }
  }
  onAdd() {
     this.pCreate.showPopup();
  }

  onSelectedVisible() {
    var dataWidth = 0;
    this.cols.forEach((e) => {
      if (e.visible == true) {
        dataWidth += e.width;
      }
    });
    this.setWidth = dataWidth + 'rem';
  }
}
